module.exports = __webpack_public_path__ + "img/6@2x.5a6a2db5.png";